import { passwordFormatInvalidMessageMap, insecurePasswordMessageMap } from './errorDictionary';
import { isPasswordSecure, isPasswordFormatValid } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidPassword() {
    const errorMessageMap = [passwordFormatInvalidMessageMap, insecurePasswordMessageMap];
    const validators = [isPasswordFormatValid, isPasswordSecure];
    return useValidators(errorMessageMap, validators);
}
export default useValidPassword;
